import React from "react";
import { object, bool, string } from "prop-types";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { PARTNER_CONTENT_STORY_TEMPLATE } from "../../../constants";
import { HeroImage } from "../../atoms/HeroImage";
import { getStoryHeadline, getStoryLabel, isExternalStory } from "../../utils/story";
import { PublishAndReadTime } from "../../atoms/PublishAndReadTime";
import { Label } from "../../atoms/Label";
import Headline from "../../atoms/Headline";

import "./four-col-five-stories-wide-hero.m.css";

export const OtherStory = ({
  story,
  showThumbnail,
  showReadTime,
  showTimestamp,
  showStorySeparator,
  defaultFallback,
  sectionSlug,
}) => {
  const sponsor = get(story, ["metadata", "sponsored-by"], null);
  const label = getStoryLabel(story);
  const isPartneredContent = story["story-template"] === PARTNER_CONTENT_STORY_TEMPLATE || sponsor !== null;
  const imageUrl =
    get(story, ["hero-image-s3-key"], "") ||
    get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], "");
  const showImageThumbnail = (showThumbnail || isPartneredContent) && (imageUrl || defaultFallback);
  const headline = getStoryHeadline(story);
  const headlineStyleName = showImageThumbnail ? "show-thumbnail" : "hide-thumbnail"; // Full width if no image

  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl ? externalStoryUrl : `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  return (
    <div styleName={`common-story ${showStorySeparator ? "" : "no-border"}`} key={story.id}>
      <Link href={href} target={target}>
        <div styleName="second-card">
          <div styleName={`left-column ${headlineStyleName}`}>
            {label && <Label story={story} />}

            {headline && <Headline styleName="heading" headline={headline} sectionSlug={sectionSlug} />}

            <PublishAndReadTime showReadTime={showReadTime} showTimestamp={showTimestamp} story={story} />
          </div>
          {showImageThumbnail && (
            <div styleName="hero-image">
              <HeroImage
                story={story}
                headline={headline}
                aspectRatio={[[4, 3]]}
                iconSizes={{ height: 24, width: 24 }}
                imageUrl={imageUrl}
              />
            </div>
          )}
        </div>
      </Link>
    </div>
  );
};

OtherStory.propTypes = {
  story: object,
  showThumbnail: bool,
  showStorySeparator: bool,
  showReadTime: bool,
  showTimestamp: bool,
  defaultFallback: bool,
  sectionSlug: string,
};
